import { render, staticRenderFns } from "./BreadNav.vue?vue&type=template&id=725a9c7e&scoped=true&"
import script from "./BreadNav.vue?vue&type=script&lang=js&"
export * from "./BreadNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725a9c7e",
  null
  
)

export default component.exports